import React from 'react';
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import useCookie from 'react-use-cookie';

import MoveClientBrowser from '../../../../modules/move/moveClientBrowser';

export default function ForceUpgraedCameraDialog(props: {
  open: boolean,
  onClose: VoidFunction,
  moveClient: MoveClientBrowser,
  deviceId: string,
  isCamera?: boolean;
}) {

  const [sent, setSent] = React.useState(false);
  const [send, setSend] = React.useState(false)

  //values are: user_url, user_chksum, rom_url, rom_chksum, kernel_url, kernel_chksum, bootloader_url, bootloader_chksum
  const [storedkernel_url, setStoredkernel_url] = useCookie("kernel_url", "");
  const [kernel_url, setkernel_url] = React.useState(storedkernel_url);
  const [storedkernel_chksum, setStoredkernel_chksum] = useCookie("kernel_chksum", "");
  const [kernel_chksum, setkernel_chksum] = React.useState(storedkernel_chksum);
  const [storeduser_url, setStoreduser_url] = useCookie("user_url", "");
  const [user_url, setuser_url] = React.useState(storeduser_url);
  const [storeduser_chksum, setStoreduser_chksum] = useCookie("user_chksum", "");
  const [user_chksum, setuser_chksum] = React.useState(storeduser_chksum);
  const [storedrom_url, setStoredrom_url] = useCookie("rom_url", "");
  const [rom_url, setrom_url] = React.useState(storedrom_url);
  const [storedrom_chksum, setStoredrom_chksum] = useCookie("rom_chksum", "");
  const [rom_chksum, setrom_chksum] = React.useState(storedrom_chksum);
  const [storedfirmwareJSON, setStoredfirmwareJSON] = useCookie("firmwareJSON", "");
  const [firmwareJSON, setfirmwareJSON] = React.useState(storedfirmwareJSON);
  const [storedfirmwareBaseURL, setStoredfirmwareBaseURL] = useCookie("firmwareBaseURL", "");
  const [firmwareBaseURL, setfirmwareBaseURL] = React.useState(storedfirmwareBaseURL);

  const [deviceSetting, setDeviceSetting] = React.useState('');
  const [deviceSettingValue, setDeviceSettingValue] = React.useState('');
  const [mac, setMACAddress] = React.useState('');

  const onClose = () => {
    setSent(false);
    setSend(false);
    props.onClose();
  }

  const onSubmit = () => {
    setSend(true);
    let partitions = {};
    if (kernel_url && kernel_url !== '') {
      partitions = { ...partitions, kernel_url }
      setStoredkernel_url(kernel_url);
    }
    if (kernel_chksum && kernel_chksum !== '') {
      partitions = { ...partitions, kernel_chksum }
      setStoredkernel_chksum(kernel_chksum);
    }
    if (user_url && user_url !== '') {
      partitions = { ...partitions, user_url }
      setStoreduser_url(user_url);
    }
    if (user_chksum && user_chksum !== '') {
      partitions = { ...partitions, user_chksum }
      setStoreduser_chksum(user_chksum);
    }
    if (rom_url && rom_url !== '') {
      partitions = { ...partitions, rom_url }
      setStoredrom_url(rom_url);
    }
    if (rom_chksum && rom_chksum !== '') {
      partitions = { ...partitions, rom_chksum }
      setStoredrom_chksum(rom_chksum);
    }
    if (Object.keys(partitions).length === 0) {
      
    } else {
      props.moveClient.CreateEvent(props.deviceId, 'ForceUpgrade', partitions)
      onClose();
    }
  }

  const onSubmitSetting = () => {
    setSend(true);
    if (deviceSetting && deviceSettingValue) {
      const jsonSetting = { [deviceSetting] : deviceSettingValue };
      props.moveClient.sendToCamera(props.deviceId, 'updateConfig', jsonSetting)
      onClose();
    }
  }

  // const onChange = (nextURL: string) => {
  //   if (send) {
  //     setSend(false);
  //   }
  //   setkernel_url(nextURL);
  // }

  const parseFirmwareJson = (json: string) => {
    let parsed = JSON.parse(json);
    if(firmwareBaseURL === '') {
      return;
    }
    let kernel_path = parsed.kernel.file_key;
    let kernel_chksum = parsed.kernel.chksum;
    if(kernel_path && kernel_path !== '' && kernel_chksum && kernel_chksum !== '') {
      setkernel_url(firmwareBaseURL + kernel_path);
      setkernel_chksum(kernel_chksum);
    }
    let rom_path = parsed.rom.file_key;
    let rom_chksum = parsed.rom.chksum;
    if(rom_path && rom_path !== '' && rom_chksum && rom_chksum !== '') {
      setrom_url(firmwareBaseURL + rom_path);
      setrom_chksum(rom_chksum);
    }
    let user_path = parsed.usr.file_key;
    let user_chksum = parsed.usr.chksum;
    if(user_path && user_path !== '' && user_chksum && user_chksum !== '') {
      setuser_url(firmwareBaseURL + user_path);
      setuser_chksum(user_chksum);
    }
    setStoredfirmwareBaseURL(firmwareBaseURL);
  }

  const onChangeSetting = (deviceSetting: string) => {
    if (send) {
      setSend(false);
    }
    setDeviceSetting(deviceSetting);
  }

  const onChangeSettingValue = (deviceValue: string) => {
    if (send) {
      setSend(false);
    }
    setDeviceSettingValue(deviceValue);
  }

  return (
    <>
      <Dialog
        open={props.open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Force Upgrade
        </DialogTitle>
        <DialogContent>
          Parse from Firmware.json:
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="firmware.json contents"
                error={send && firmwareJSON === ''}
                value={firmwareJSON}
                onChange={(event) => parseFirmwareJson(event.target.value)}
              />
            )}
          </Box>
          Parsing Base URL:
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="eg. https://s3....com/pepperos-....firmware/<MODEL>/"
                error={send && firmwareBaseURL === ''}
                value={firmwareBaseURL}
                onChange={(event) => setfirmwareBaseURL(event.target.value)}
              />
            )}
          </Box>
          Kernel:
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Kernel URL"
                error={send && kernel_url === ''}
                value={kernel_url}
                onChange={(event) => setkernel_url(event.target.value)}
              />
            )}
          </Box>
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Kernel Chksum"
                error={send && kernel_chksum === ''}
                value={kernel_chksum}
                onChange={(event) => setkernel_chksum(event.target.value)}
              />
            )}
          </Box>
          Rom:
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Rom URL"
                error={send && rom_url === ''}
                value={rom_url}
                onChange={(event) => setrom_url(event.target.value)}
              />
            )}
          </Box>
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Rom Chksum"
                error={send && rom_chksum === ''}
                value={rom_chksum}
                onChange={(event) => setrom_chksum(event.target.value)}
              />
            )}
          </Box>
          User:
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="User URL"
                error={send && user_url === ''}
                value={user_url}
                onChange={(event) => setuser_url(event.target.value)}
              />
            )}
          </Box>
          <Box display="flex" flexDirection="column" sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="User Chksum"
                error={send && user_chksum === ''}
                value={user_chksum}
                onChange={(event) => setuser_chksum(event.target.value)}
              />
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>
            Close
          </Button>
          {!sent && (
            <Button
              variant='contained'
              onClick={onSubmit}
            >
              Send
            </Button>
          )}
        </DialogActions>
        <DialogTitle>
          Manual Setting
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" rowGap={2} sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Setting"
                error={send && deviceSetting === ''}
                value={deviceSetting}
                onChange={(event) => onChangeSetting(event.target.value)}
              />
            )}

          </Box>
          <Box display="flex" flexDirection="column" rowGap={2} sx={{ pt: 1, }}>
            {!sent && (
              <TextField
                label="Value"
                error={send && deviceSettingValue === ''}
                value={deviceSettingValue}
                onChange={(event) => onChangeSettingValue(event.target.value)}
              />
            )}

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>
            Close
          </Button>
          {!sent && (
            <Button
              variant='contained'
              onClick={onSubmitSetting}
            >
              Send
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}